module.exports = __webpack_public_path__ + "img/about-4.fa7f7304.png";